import { render, staticRenderFns } from "./audio-item.vue?vue&type=template&id=0c7c38d1&scoped=true&"
import script from "./audio-item.vue?vue&type=script&lang=js&"
export * from "./audio-item.vue?vue&type=script&lang=js&"
import style0 from "./audio-item.vue?vue&type=style&index=0&id=0c7c38d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c38d1",
  null
  
)

export default component.exports